const ResumeApi = [
  {
    id: 1,
    category: "education",
    year: "Savitribai Phule Pune University (2020- 2022)",
    title: "Master of Computer Science (MCS)",
    desc: "Abasaheb Garware College",
  },
  {
    id: 2,
    category: "education",
    year: "Savitribai Phule Pune University (2017 - 2020) ",
    title: "Bachelor of Computer Science (BCS)",
    desc: "Haribhai V. Desai College",
  },
  {
    id: 3,
    category: "education",
    year: "The Maharashtra State Board of Secondary & Higher Secondary Education, Pune (2015 - 2017) ",
    title: "HSC",
    desc: "Bharat English High School and Junior College",
  },
  {
    id: 4,
    category: "education",
    year: "The Maharashtra State Board of Secondary & Higher Secondary Education, Pune (2015 - 2017) ",
    title: "SSC",
    desc: "Modern High School",
  },
]

export default ResumeApi
